import React, { useState } from 'react';

interface DataSummaryProps {
  summary: any;
  onStatusChange: (statuses: string[]) => void;
}

export const DataSummary = ({ summary, onStatusChange }: DataSummaryProps) => {
  const [dataSummaryStatus, setDataSummaryStatus] = useState('');

  const getStatusArray = (clickedStatus: string): string[] => {
    switch (clickedStatus) {
      case 'New Patient Leads':
        return ['scheduled', 'contacted', 'not_contacted', 'declined'];
      case 'New Patients Scheduled':
        return ['scheduled'];
      case 'New Patients Unscheduled':
        return ['contacted', 'not_contacted'];
      default:
        return [];
    }
  };

  const handleStatusClick = (label: string) => {
    setDataSummaryStatus(label);
    const statusArray = getStatusArray(label);
    onStatusChange(statusArray);
  };

  const generateDataSummary = (summaryData: any) => {
    const summaryConfig = [
      {
        key: 'total',
        color: 'text-[#55B494]',
        label: 'New Patient Leads',
      },
      {
        key: 'scheduled',
        color: 'text-[#5B73F1]',
        label: 'New Patients Scheduled',
      },
      {
        key: 'unscheduled',
        color: 'text-[#C39502]',
        label: 'New Patients Unscheduled',
      },
    ];

    return summaryConfig.map(({ key, color, label }) => ({
      color,
      value: summaryData?.[key] || 0,
      label,
    }));
  };

  const dataSummary = generateDataSummary(summary);

  return (
    <div className="fixed z-10 top-[5.5625rem] w-[calc(100vw-12.75rem)]">
      <ul className="flex gap-6 items-center overflow-x-auto [&::-webkit-scrollbar]:hidden">
       {dataSummary.map((item, index) => (
         <li
           key={index}
           className="flex gap-2 items-end cursor-pointer"
           onClick={() => handleStatusClick(item.label)}
         >
           <span className={`inline-block text-xl font-semibold leading-6 ${item.color}`}>
            {item.value}
           </span>
           <p className="text-[#343A3F] text-xs font-normal leading-[1.2rem] whitespace-nowrap">
             {item.label}
           </p>
         </li>
        ))}
      </ul>
    </div>
  );
};
